import * as Header from '../../constants/Header';

// TODO:constantsにうつす
// 0: なし
const NONE: number = 0;
// 1: メニューに戻る
const BACK_MENU: number = 1;
// 2: 利用者一覧に戻る
const BACK_USER_LIST: number = 2;
// 3: 管理画面に戻る
const SETTING: number = 3;

const initialState = {
  // ログインはデフォルトなので
  title: 'モフトレ・ダッシュボード',
  // 左上のバック
  back_type: NONE,
  // 右上の検索枠の有無
  is_search: false,
  // 右上の利用者設定の新規登録ボタンの有無
  is_register_btn: false,
  // 右上の利用者設定ボタンの有無
  is_user_setting_btn: false,
  // 右上のログアウトの有無
  is_logout: false,
  // モフトレ通信など特殊なのはヘッダなし.
  no_header: false,
};

// プロパティ名になる.
export default function header(state: any = initialState, action: any) {
  // alert(action.type);
  switch (action.type) {
    case Header.LOGIN:
      return Object.assign({}, state, {
        title: 'モフトレ・ダッシュボード',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.MENU:
      return Object.assign({}, state, {
        title: 'レポートメニュー',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: true,
        is_logout: true,
      });
    case Header.USER_SELECT_LOCOMO:
      return Object.assign({}, state, {
        title: '利用者一覧(ロコモ予防トレーニング)',
        back_type: BACK_MENU,
        is_search: true,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.LOCOMO:
      return Object.assign({}, state, {
        title: 'ロコモ予防トレーニング',
        back_type: BACK_USER_LIST,
        // スラッシュ必須.
        back_url: '/user_select_locomo',
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.USER_SELECT_ADL:
      return Object.assign({}, state, {
        title: '利用者一覧(日常生活動作トレーニング)',
        back_type: BACK_MENU,
        is_search: true,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.ADL:
      return Object.assign({}, state, {
        title: '日常生活動作トレーニング',
        back_type: BACK_USER_LIST,
        // スラッシュ必須.
        back_url: '/user_select_adl',
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.USER_SELECT_KIROKU:
      return Object.assign({}, state, {
        title: '個別機能訓練に関する記録',
        back_type: BACK_MENU,
        is_search: true,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.KIROKU:
      return Object.assign({}, state, {
        title: '個別機能訓練に関する記録',
        // スラッシュ必須.
        back_url: '/user_select_kiroku',
        back_type: BACK_USER_LIST,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.USER_SELECT_PRESS:
      return Object.assign({}, state, {
        title: '利用者一覧(モフトレ通信)',
        back_type: BACK_MENU,
        is_search: true,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.PRESS_SELECT_MONTH:
      return Object.assign({}, state, {
        title: 'モフトレ通信',
        // スラッシュ必須.
        back_url: '/user_select_press',
        back_type: BACK_USER_LIST,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.PRESS:
      return Object.assign({}, state, {
        title: 'モフトレ通信',
        back_type: NONE,
        is_search: false,
        is_register_btn: false,
        is_logout: false,
        is_user_setting_btn: false,
        no_header: true,
      });
    case Header.USER_SELECT_MOFF_CHECK:
      return Object.assign({}, state, {
        title: '利用者一覧(モフトレチェック)',
        back_type: BACK_MENU,
        is_search: true,
        is_logout: false,
      });
    case Header.MOFF_CHECK_SELECT_MONTH:
      return Object.assign({}, state, {
        title: 'モフトレチェック',
        // スラッシュ必須.
        back_url: '/user_select_moff_check',
        back_type: BACK_USER_LIST,
        is_search: false,
        is_logout: false,
      });
    case Header.USER_INTEREST_CHECK:
      return Object.assign({}, state, {
        title: '利用者一覧(興味関心チェック)',
        // スラッシュ必須.
        back_url: '/user_setting',
        back_type: BACK_MENU,
        is_search: true,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.INTEREST_CHECK_PRINT:
      return Object.assign({}, state, {
        title: '興味関心チェックシート',
        // スラッシュ必須.
        back_url: '/user_interest_check',
        back_type: BACK_USER_LIST,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.HOME_VISIT:
      return Object.assign({}, state, {
        title: '利用者一覧(居宅訪問)',
        back_url: '/user_setting',
        back_type: BACK_MENU,
        is_search: true,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.HOME_VISIT_PRINT:
      return Object.assign({}, state, {
        title: '居宅訪問チェックシート',
        // スラッシュ必須.
        back_url: '/home_visit',
        back_type: BACK_USER_LIST,
        is_search: false,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    // TODO:
    case Header.USER_SELECT_LITERALLY_REPORT:
      return Object.assign({}, state, {
        title: '利用者一覧(機能訓練レポート)',
        back_type: BACK_MENU,
        is_search: true,
        is_register_btn: false,
        is_user_setting_btn: false,
        is_logout: false,
      });
    case Header.LITERALLY_REPORT_SELECT_MONTH:
      return Object.assign({}, state, {
        title: '機能訓練レポート',
        // スラッシュ必須.
        back_url: '/user_select_literally_report',
        back_type: BACK_USER_LIST,
        is_search: false,
        is_logout: false,
      });
    case Header.SETTING:
    case Header.SETTING_FORGOT_PASSWORD_CODE:
      return Object.assign({}, state, {
        title: '管理',
        back_type: NONE,
        is_search: false,
        is_logout: true,
      });
    case Header.SETTING_CHANGE_PASSWORD:
    case Header.SETTING_FORGOT_PASSWORD:
      return Object.assign({}, state, {
        title: '管理',
        back_url: '/settings.html',
        back_type: SETTING,
        is_search: false,
        is_logout: true,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/Header.tsx